<div class="modal-backdrop" [@modalAnimation]="animationState">
  <div class="completion-modal" [ngClass]="completionType">
    <div class="confetti-container">
      @for (i of completionType === CompletionType.ISSUE ? [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20] : [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]; track i) {
        <div class="confetti"></div>
      }
    </div>

    <div class="completion-icon" [@confettiAnimation]>
      <div class="checkmark-circle" [ngClass]="completionType">
        <div class="checkmark"></div>
      </div>
    </div>

    <div class="completion-message" [@confettiAnimation]>
      {{message}}
    </div>

    @if (completionType === CompletionType.ISSUE) {
      <div class="completion-subtitle" [@confettiAnimation]>
        🎉 Great achievement! 🎉
      </div>
    }

    @if (taskTitle) {
      <div class="task-title" [@confettiAnimation]>
        "{{taskTitle}}"
      </div>
    }

    @if (showPoints && pointsValue !== null) {
      <div class="completion-points" [@confettiAnimation]>
        <span class="points-badge" [ngClass]="completionType">+{{pointsValue}}</span>
      </div>
    }
  </div>
</div>
